export const gridColumnDefinitions =[
    { field: 'Date',
     headerName: 'Date',
      width: 150,
    cellStyle:{"defaultStyle": {'fontSize': '8px', 'textAlign': 'center'} }
   },
    {
      field: 'Code1',
      headerName: 'Series1',
      width: 100,
      editable: false,
      cellStyle:{"defaultStyle": {'fontSize': '8px', 'text-align': 'center'} }
    },
    {
      field: 'Code1_name',
      headerName: 'Series1_Name',
      width: 250,
      editable: false,
      cellStyle:{"defaultStyle": {'fontSize': '8px', 'text-align': 'center'} }
    },
    {
      field: 'Code2',
      headerName: 'Series2',
      type: 'string',
      width: 100,
      editable: true,
      cellStyle:{"defaultStyle": {'fontSize': '8px', 'justify-content': 'center'} }
    },
  
    {
      field: 'Code2_name',
      headerName: 'Series2_Name',
      width: 350,
      editable: false,
      cellStyle:{"defaultStyle": {'fontSize': '8px', 'text-align': 'center'} }
    },
  {
    field: 'Static_Correlation',
    headerName: 'Static Correlation',
    type: 'number',
    width:150,
    editable: true,          
    },
  ]



export const metricColumnDef = [
  { field: 'Metric',
    headerName: 'Metric',
    width: 350,
    tooltipField: 'Metric',
    cellDataType: 'text'
    //cellStyle:{"defaultStyle": {'fontSize': '8px', 'text-align': 'center'}} 
  },
  {
    field: 'Benchmark',
    headerName: 'Benchmark',
    width: 350,
    cellDataType: 'text'
    //cellStyle:{"defaultStyle": {'fontSize': '8px', 'text-align': 'center'}
   
  },
  {
    field: 'Strategy',
    headerName: 'Strategy',
    width: 350,
    cellDataType: 'text'
    //cellStyle:{"defaultStyle": {'fontSize': '8px', 'text-align': 'center'} }
  }
]